<script setup>
import { useRoute } from '@js/utils/route';
import { ref } from 'vue';

const { phoneCall, callback } = defineProps({
    phoneCall: {
        type: Object,
        required: true,
    },
    callback: {
        type: Function,
        required: false,
    },
});

const { route } = useRoute();

const loading = ref(false);

function invalidatePhoneCall() {
    loading.value = true;

    axios
        .post(
            route('front.projectManagement.apikom.postInvalidatePhoneCall', {
                phoneCall: phoneCall.id,
            }),
        )
        .then(() => {
            if (callback) {
                callback();
            }
        })
        .finally(() => {
            loading.value = false;
        })
        .catch((error) => {
            console.error(error);
        });
}
</script>

<template>
    <slot name="button" :action="invalidatePhoneCall" :loading="loading" />
</template>
